<template>
  <div class="mh3 mh4-l mb4">
    <portal to="nav-bar">
      <nav-back-to-list />
    </portal>

    <async-component :asyncFunction="loadDocumentTemplate" #default="{ loading, error }">
      <content-spinner v-if="loading" class="mv4"/>
      <div v-else-if="error" class="mv4">Ошибка: {{ error }}</div>
      <div v-else>
        <div class="section-layout border pv3">
          <div class="section-title b lh-copy text-primary ttl">
            Редактирование шаблона
          </div>
          <div class="section-data">
            <a href="#" class="link dim underline blue ttl mr3" @click.prevent="saveFields">
              Сохранить
            </a>
            <a href="#" class="link dim underline blue ttl" @click.prevent="downloadTemplate">
              Скачать
            </a>
          </div>
        </div>

        <div class="horizontal-input-layout pv3">
          <span class="horizontal-input-label ttl text-secondary">Шаблон:</span>
          <input class="text-input bg-middle horizontal-input-data data-layout b" type="text" v-model="titleModel">
          <!--
          <span style="color: red" class="horizontal-input-error">{{ e }}</span>
          -->
        </div>

        <div class="section-layout mt4 border pb3">
          <div class="section-title b lh-copy text-primary ttl">поля шаблона</div>
          <div class="section-data flex">
            <a v-for="(action, index) in fieldFormActions" :key="index"
              href="#" class="link dim underline blue ttl mr3" @click.prevent="acceptFieldsAction(action)">
              {{ action.title }}
            </a>
          </div>
        </div>

        <fields-form v-model="formFields" class="mt3"/>
      </div>
    </async-component>
  </div>
</template>

<script>
import NavBackToList from '@/components/common/NavBackToList.vue'
import AsyncComponent from '@/components/AsyncComponent.vue'
import ContentSpinner from '@/components/ui/progress/ContentSpinner.vue'
import FieldsForm from '@/components/document_templates/FieldsForm.vue'
import { DataService } from '@/services/DataService.js'
import { download } from '@/utils/download'

export default {
  components: {
    NavBackToList,
    AsyncComponent,
    ContentSpinner,
    FieldsForm
  },
  props: ['id'],
  data () {
    return {
      title: null,
      fields: [],
      changed: false,
      saving: false,
      fieldFormActions: [{
        title: 'очистить',
        enabled: true,
        code: 'clear'
      }]
    }
  },
  computed: {
    formFields: {
      get () { return this.fields },
      set (fields) {
        this.fields = fields
        this.changed = true
      }
    },
    titleModel: {
      get () { return this.title },
      set (title) {
        this.title = title
        this.changed = true
      }
    }
  },
  methods: {
    loadDocumentTemplate () {
      return DataService.getDocumentTemplates({ filter: { id: +this.id }, limit: 1, offset: 0 })
        .then(({ data: { documentTemplates: { data } } }) => {
          if (!data.length) return
          if (!data[0].fields) return
          this.title = data[0].title
          this.fields = data[0].fields
        })
    },
    async saveFields () {
      this.saving = true
      return DataService.updateDocumentTemplate({ templateId: +this.id, title: this.title, fields: this.fields })
        .then(({ data: { updateDocumentTemplate: { id, title, fields } }, errors }) => {
          if (errors) {
            this.error = 'Произошла ошибка'
            this.$store.dispatch('notification/add', {
              title: 'Произошла ошибка. Проверьте параметры.',
              type: 'info'
            })
          } else {
            this.$store.dispatch('notification/add', {
              title: 'Шаблон сохранен',
              type: 'info'
            })
            this.changed = false
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
    downloadTemplate () {
      DataService.loadDocumentTemplate({ templateId: this.id })
        .then(({ data: { loadDocumentTemplate: { data, name } } }) => download(data, name))
    },
    acceptFieldsAction (action) {
      if (action.code === 'clear') {
        this.fields = this.fields.map(({ name, settings }) => {
          return { name, value: null, settings }
        })
      }
    }
  },
  beforeDestroy () {
    if (this.changed) {
      if (window.confirm('Есть несохраненные изменения! Сохранить?')) {
        this.saveFields()
      } else {
        // не сохранять...
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // TODO: это сейчас не работает так как в данный компонент не указан в свойстве сomponent
    // в router/index.js. там сейчас Cabinet.vue. Надо это переделать,
    // но так чтобы лейаут грузился бы в первую очередь до загрузки данного компонента при переходе на другой URL
    if (this.changed) {
      if (window.confirm('Есть несохраненные изменения! Все равно покинуть страницу?')) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
.section-layout {
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto auto;
  align-items: center;
}
.section-title {
  justify-self: end;
  padding-right: .5rem;
}
.section-data {
  justify-self: start;
}
.border {
  border-bottom-style: solid;
  border-bottom-width: .1rem;
  border-color: #F0F4F8
}
</style>
